import { FactsFiguresProps } from '@/components/facts-figures/types';
import React from 'react';
import clsx from 'clsx';
import { BaseImage } from '@/components/baseImage/BaseImage';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { Headline } from '@/components/headline/Headline';
import { renameDomProps } from '@/utils/sanitizeDomProps';

export const FactsFigures: React.FC<FactsFiguresProps> = ({
  headline,
  description,
  image,
  className,
  items,
  name,
  position,
  sectionId,
  ...rest
}) => {
  const renamedProps = renameDomProps(rest);
  return (
    <div
      data-component-id="C021"
      id={sectionId}
      className={clsx(
        'smzh-facts-figures container relative mx-auto grid grid-cols-4 items-start justify-between gap-6 px-4 py-14 sm:px-0 md:grid-cols-12 md:gap-14',
        className,
      )}
      {...renamedProps}
    >
      <div className="col-span-full flex flex-col gap-10 md:col-start-1 md:col-end-7">
        <div className="flex flex-col gap-6">
          <Headline {...headline} className={'!my-0 text-brand-700'}>
            {headline.title}
          </Headline>
          {description && (
            <div className="fact-figures-content text-neutral-700 md:text-lg">
              <SerializeDescription description={description} />
            </div>
          )}
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex h-36 w-36 flex-col self-start overflow-hidden rounded-full">
            {image && <BaseImage {...image} quality={30} sizes="144px" />}
          </div>
          <div className="flex flex-row text-base font-normal text-brand-700 md:text-lg">
            {name && <span>{name}</span>}
            {position && (
              <span>
                , <strong>{position}</strong>
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-full flex flex-col md:col-start-9 md:col-end-13 md:pt-10">
        {items.map((item, index) => (
          <div
            className="flex flex-col gap-2 border-b border-neutral-100 py-6"
            key={index}
          >
            <span className="text-4xl font-semibold tracking-tight text-brand-700 md:text-5xl">
              {item.stats}
            </span>
            <span className="ml-0.5 text-base font-light text-neutral-700 md:text-lg">
              {item.subtitle}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
